import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  background: ${(props) => props.theme.colours.bg};
  color: white;
`

// TODO: Large circular gradient background colour as per Carsten's design

// Layout is a top-level container designed to fill the entire viewport.
// Children are typically: <SideMenu/><WhateverMainComponent/>
const Layout = ({ children }) => <Container>{children}</Container>

Layout.propTypes = {
  children: PropTypes.any,
}

export default Layout
